import { defineMessages } from 'react-intl-next';

export default defineMessages({
	title: {
		id: 'project-pages.improvement.transient-states.empty-state.title',
		defaultMessage: 'There’s nothing here but potential',
		description: 'Title of message letting users know there are no pages',
	},
	description: {
		id: 'project-pages.improvement.transient-states.empty-state.description',
		defaultMessage:
			'Create some meeting notes, product requirements, decisions, or other content to see this space fill up.',
		description: 'Description text letting users know there are no pages',
	},
	confluenceAutoProvisionedDescription: {
		id: 'project-pages.improvement.transient-states.empty-state.auto-provisioned-description',
		defaultMessage:
			'We’ve added Confluence so you can start creating and linking all your project documents. It’s free for up to 10 users.',
		description: 'Description text letting users know Confluence has been auto provisioned',
	},
	createFirstPageButton: {
		id: 'project-pages.improvement.transient-states.empty-state.create-page-button',
		defaultMessage: 'Create your first page',
		description: 'Button label for creating a new first page',
	},
	createPageButton: {
		id: 'project-pages.improvement.transient-states.empty-state.auto-provisioned-create-page-button',
		defaultMessage: 'Create page',
		description: 'Button label for creating a new page',
	},
	learnMoreButton: {
		id: 'project-pages.improvement.transient-states.empty-state.auto-provisioned-learn-more-button',
		defaultMessage: 'Learn more',
		description: 'Label for link to Confluence guides, tutorials and demos',
	},
	tutorialPageName: {
		id: 'project-pages.improvement.templates.tutorial.name',
		defaultMessage: 'Welcome to Project Pages!',
		description: 'Title of the tutorial page',
	},
});
